import React from 'react'
import styled from 'styled-components'
import FreeShippingMembership from './FreeShippingMembership'
import useMembershipElementShow from '../../../../../../hooks/useMembershipElementShow'
import { useMembershipStorage } from '../../../../../../hooks/useMembershipStorage'

const StyledContainer = styled.div`
  border-radius: 4px;
  background: #ffcd05;
  height: 24px;
  width: 90px;
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 12px 0;
  display: flex;
  justify-content: center;
`
const StyledContainerCarosuel = styled.div`
  border-radius: 4px;
  background: #ffcd05;
  height: 28px;
  width: 90px;
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 12px 0;
  text-align: center;
  line-height: 20px;
  padding-top: 2px;
  position: relative;
  display: inline-flex;
  justify-content: center;
  gap: .25rem;
  border-radius: .25rem;
  align-items: center;
`

const FreeShippingBadgeWmo = ({
  sku, isFreeShipping = true, isFreeShippingForMembers = false, isCarousel = false,
}) => {
  const showMembership = useMembershipElementShow()
  const { membershipStorage } = useMembershipStorage()
  const hasActiveMembership = membershipStorage?.membership_status === 'ACTIVE'
  if (isFreeShipping) {
    if (isCarousel) {
      return (
        <StyledContainerCarosuel
          id={`free-shipping-${sku}`}
          data-testid="carousel-freeshipping-badge"
        >
          Free Shipping
        </StyledContainerCarosuel>
      )
    }
    return (
      <StyledContainer
        id={`free-shipping-${sku}`}
        data-testid="freeshipping-badge"
      >
        Free Shipping
      </StyledContainer>
    )
  }

  if ((showMembership || hasActiveMembership) && isFreeShippingForMembers) {
    return <FreeShippingMembership sku={sku} isCarousel={isCarousel} />
  }

  return null
}

export default FreeShippingBadgeWmo
